var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "400px" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-text-field", {
                staticStyle: { padding: "0 25px" },
                model: {
                  value: _vm.newTag,
                  callback: function ($$v) {
                    _vm.newTag = $$v
                  },
                  expression: "newTag",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonLoading, color: "primary" },
                  on: { click: _vm.onPressUse },
                },
                [_vm._v("CHANGE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }